var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonArrowHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9697 6.46967C14.2626 6.17678 14.7374 6.17678 15.0303 6.46967L20.0303 11.4697C20.3232 11.7626 20.3232 12.2374 20.0303 12.5303L15.0303 17.5303C14.7374 17.8232 14.2626 17.8232 13.9697 17.5303C13.6768 17.2374 13.6768 16.7626 13.9697 16.4697L18.4393 12L13.9697 7.53033C13.6768 7.23744 13.6768 6.76256 13.9697 6.46967Z",
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6893 11.25H9.5C8.54665 11.25 7.13332 11.5298 5.93677 12.3914C4.70198 13.2804 3.75 14.7556 3.75 17C3.75 17.4142 4.08579 17.75 4.5 17.75C4.91421 17.75 5.25 17.4142 5.25 17C5.25 15.2444 5.96468 14.2196 6.81323 13.6087C7.70002 12.9702 8.78668 12.75 9.5 12.75L17.6893 12.75L18.4393 12L17.6893 11.25Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1931 11.7129C20.2298 11.8013 20.25 11.8983 20.25 12C20.25 11.9023 20.231 11.8046 20.1931 11.7129Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrowHover);
export default __webpack_public_path__ + "static/media/button-arrow-hover.f0e8eb209af414b4255eb89808b33b9d.svg";
export { ForwardRef as ReactComponent };